<template>
  <div ref="strip" class="s-booking-layout">
    <Loader v-if="isLoading"></Loader>
    <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs"></Alert>

    <form autocomplete="off" @submit.prevent="onSubmitForm">
      <div class="s-booking-layout__body">
        <div class="s-booking-layout__main">
          <BookingExtrasList @change-payment="onChangePayment" />

          <div class="d-flex justify-content-center">
            <button type="submit" class="btn btn-primary">
              {{ dictionary.buttonSubmitText }}
            </button>
          </div>
        </div>

        <div class="s-booking-layout__aside">
          <div v-if="showMilesToggle" class="s-booking-layout__miles mb-16">
            <div class="s-booking-layout__miles__title">
              <div class="new">{{ mbDictionary.milesNBonusTagLabel }}</div>
              <span class="bold">
                {{ mbDictionary.milesNBonusToggleTitle }}
              </span>
            </div>
            <div class="form-check form-switch">
              <label class="form-check-label" for="toggleMiles">
                <span v-if="toggleMiles">
                  {{ mbDictionary.milesNBonusToggleMilesLabel }}
                </span>
                <span v-else>
                  {{ mbDictionary.milesNBonusToggleEuroLabel }}
                </span>
              </label>
              <input
                id="toggleMiles"
                v-model="toggleMiles"
                class="form-check-input"
                type="checkbox"
                role="switch"
                @change="onToggleMiles" />
            </div>
          </div>

          <div class="d-block d-lg-none">
            <BookingAsideAccordion
              v-if="vehicle"
              :item="vehicle"
              :payment="payment">
              <BookingAside :item="vehicle" :payment="payment" />
            </BookingAsideAccordion>
          </div>

          <BookingAside
            v-if="vehicle"
            class="d-none d-lg-block"
            :item="vehicle"
            :payment="payment"
            :show-submit-button="true"
            @submit="onSubmitAside" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import Loader from './common/Loader.vue'
import Alert from './common/Alert.vue'
import axios from 'axios'
import BookingAside from './BookingAside.vue'
import BookingAsideAccordion from './BookingAsideAccordion.vue'
import BookingExtrasList from './BookingExtrasList.vue'

export default {
  components: {
    Alert,
    Loader,
    BookingAside,
    BookingAsideAccordion,
    BookingExtrasList,
  },
  data() {
    return {
      isLoading: false,
      errorMsgs: [],
      vehicle: null,
      payment: null,
      token: '',

      mbDictionary: {},
      milesNBonusLoggedIn: false,
      showMilesNBonus: lib.getData('milesNBonusData'),
      redeemAllowed: false,
      toggleMiles: false,
    }
  },
  computed: {
    showMilesToggle() {
      return (
        this.milesNBonusLoggedIn &&
        this.showMilesNBonus &&
        this.payment.IsPrepaid &&
        this.redeemAllowed
      )
    },
  },
  mounted() {
    const { token, vehicle, Payment } = lib.getData('bookingData')
    this.token = token
    this.vehicle = vehicle
    this.payment = Payment

    if (lib.getData('milesNBonusData')) {
      const { configuration, dictionary } = lib.getData('milesNBonusData')
      this.milesNBonusLoggedIn = configuration.milesNBonusLoggedIn
      this.redeemAllowed = configuration.redeemAllowed
      this.mbDictionary = dictionary

      if (!configuration.destinationAllowed) {
        this.showMilesNBonus = false
      }

      this.setEventListeners()
    }
  },
  methods: {
    onToggleMiles() {
      document.dispatchEvent(
        new CustomEvent('toggleMiles', { detail: { value: this.toggleMiles } })
      )
    },

    setEventListeners() {
      document.addEventListener('milesNBonusLogStatus', (e) => {
        this.milesNBonusLoggedIn = e.detail.logStatus
        this.redeemAllowed = e.detail.redeemAllowed
      })
    },

    onChangePayment(payment, token) {
      this.payment = payment
      this.token = token
    },

    onSubmitAside() {
      this.onSubmitForm()
    },

    onSubmitForm() {
      this.isLoading = true

      const postData = { Token: this.token }
      axios
        .post(this.configuration.endpointSubmitData, postData)
        .then((response) => {
          const { HasError, Errors, Url } = response.data
          // response has error
          if (HasError) {
            this.handleError(Errors)
            return false
          }

          window.location.assign(Url)
          this.errorMsgs = []
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false

      this.$nextTick(() => {
        lib.scrollToError(100)
      })
    },
  },
}
</script>
